export default __webpack_public_path__ + "static/media/kinder3.c0050824.jpg";